import ShareButton from "PFApp/components/activity_share/share_button";
import { Typography } from "PFComponents/typography";
import { useRoleName } from "PFCore/helpers/activities";
import { ActivitiesCollection } from "PFCore/hooks/queries/activities/query_keys";
import { useActivitiesInvalidate } from "PFCore/hooks/queries/activities/use_activities_invalidate";
import { MatchedActivity } from "PFTypes";
import React from "react";

import tertiaryTheme from "../../../../../components/buttons/marketplace_tertiary_button.module.scss";
import css from "./header.module.scss";
import { InterestedButton } from "./interested_button";
import { SaveButton } from "./save_button";

export const Header = ({ role }: { role: MatchedActivity["activity"] }) => {
  const { invalidateByCollection } = useActivitiesInvalidate();
  const getRoleName = useRoleName();

  return (
    <div className={css.container}>
      <Typography className={css.title} variant="h2">
        {getRoleName(role)}
      </Typography>
      <SaveButton role={role} />
      <ShareButton
        classes={tertiaryTheme}
        activityType="role"
        kind="tertiary"
        activityIds={[role.id]}
        withTitle={false}
        onSuccess={() => {
          invalidateByCollection(ActivitiesCollection.MarketplaceActivity, role.id);
        }}
      />
      <InterestedButton role={role} />
    </div>
  );
};
